import { TableColumn } from 'react-data-table-component';
import { Link } from 'react-router-dom';

import { TrapDevice } from 'api/traps/DevicesWareHouse/types';
import { useQRCodeModalStore } from 'components/QRCodeModal/QRCodeModal';
import { Breakpoints } from 'hooks/Screen/useScreenSize';
import { useTrapDeleteModalStore } from 'components/DeleteTrapModal/TrapsDeleteModal';
import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetTableMCTColumns = (isAll: boolean, trapType: TrapType): TableColumn<TrapDevice>[] => {
  const { onQRCodeModalOpen } = useQRCodeModalStore();
  const { openDeleteTrapModal } = useTrapDeleteModalStore();

  const columns: TableColumn<TrapDevice>[] = [
    {
      name: 'Serial Number',
      selector: row => row.serial_number,
      sortable: true,
      sortField: 'serial_number',
    },
  ];

  if (isAll) {
    columns.unshift({
      name: 'Number',
      selector: row => row.model_trap_type || 0,
      sortable: true,
      sortField: 'sequence_number',
      grow: 0.8,
      cell: row =>
        row.is_used ? (
          <LinkCell
            title={String(row.sequence_number) || 'None'}
            link={`/${row.is_used.detail_page_url_ending}`}
            toReact
            icon="ri-eye-line"
          />
        ) : (
          <LinkCell title="None" link="#" toReact icon="ri-eye-line" />
        ),
    });
    (trapType === TrapType.SMST || trapType === TrapType.SRST) &&
      columns.push({
        name: 'Snaps Count',
        selector: row => row.snaps_count,
        hide: Breakpoints.Mobile,
        cell: row => <div>{row.snaps_count || 0}</div>,
      });
    columns.splice(3, 0, {
      name: 'Use Site',
      selector: row => row.object_name,
      sortField: 'object_name',
      sortable: true,
      style: {
        justifyContent: 'start',
        marginLeft: '10px',
      },
      grow: 1.5,
      hide: Breakpoints.LargeDesktop,
      cell: row =>
        row.is_used ? (
          <Link to={`/object/traps/${row.object_slug}`} className="link-cell-item text-truncate">
            <div className="icon">
              <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
            </div>

            <div className="text w-100 d-flex align-items-center justify-content-center">
              <span>{row.is_used.site_name || 'None'}</span>
            </div>
          </Link>
        ) : (
          <Link to="#" className="link-cell-item text-truncate">
            <div className="icon">
              <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
            </div>

            <div className="text w-100 d-flex align-items-center justify-content-center">
              <span>None</span>
            </div>
          </Link>
        ),
    });

    columns.push({
      name: 'Actions',
      selector: row => row.serial_number,
      hide: Breakpoints.Mobile,
      cell: row => (
        <div>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => openDeleteTrapModal(row.id, row.serial_number, true)}
          >
            <i className="ri-delete-bin-6-fill" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() =>
              onQRCodeModalOpen(`${process.env.REACT_APP_BASE_DJANGO_URL}${row?.qr_code}`, row?.serial_number)
            }
          >
            <i className="ri-qr-code-fill text-dark icon icon__qr-code" />
          </button>
        </div>
      ),
    });
  }

  if (!isAll) {
    columns.splice(1, 0, {
      name: 'Model',
      selector: row => row.model_trap_type,
      sortable: true,
      sortField: 'model_trap_type',
      hide: Breakpoints.Mobile,
    });
    columns.push({
      name: 'Actions',
      selector: row => row.serial_number,
      cell: row => (
        <div>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => openDeleteTrapModal(row.id, row.serial_number, false)}
          >
            <i className="ri-delete-bin-6-fill" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() =>
              onQRCodeModalOpen(`${process.env.REACT_APP_BASE_DJANGO_URL}${row?.qr_code}`, row?.serial_number)
            }
          >
            <i className="ri-qr-code-fill text-dark icon icon__qr-code" />
          </button>
        </div>
      ),
    });
  }

  return columns;
};
